export default __webpack_public_path__ + "static/media/illus_tut1.529d286d.png";